export class DownloadUtils {
  static downloadCSV(data: string, fileName: string): void {
    const link = document.createElement('a')
    const blob = new Blob([data], { type: 'application/csv' })
    link.href = window.URL.createObjectURL(blob)
    link.download = `${fileName}.csv`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }
  static downloadFromUri(uri: string): void {
    const link = document.createElement('a')
    link.href = uri
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }
}
